import {WithSummaryModel} from "../../../../../../../common/entity/dto/plain/withSummary.model";

import {TreatmentJourneySummaryModel} from "./treatmentJourneySummary.model";
import {
    ConsultationSummaryModel
} from "../../../../../../consultation/consultation/api/model/consultationSummary.model";
import {
    TreatmentJourneyDefinitionSummaryModel
} from "../../../../definition/journey/api/entity/treatmentJourneyDefinitionSummary.model";
import {TreatmentJourneyStepModel} from "../../../step/api/entity/treatmentJourneyStep.model";

export class TreatmentJourneyModel extends WithSummaryModel<TreatmentJourneySummaryModel> {
    steps: TreatmentJourneyStepModel[] = [];
    consultation: ConsultationSummaryModel;
    definition: TreatmentJourneyDefinitionSummaryModel;
}